import { QuestionType } from "../enums/question";
export const QUESTION_TYPES_WITH_CHOICES = [QuestionType.Multiple, QuestionType.MultipleCheckboxes];
